/**
 * Dashboard Widget Type Definitions
 * Common types and configurations for dashboard widgets
 */

export const WIDGET_TYPES = {
  QUICK_ACTIONS: 'quick_actions',
  RECENT_ACTIVITY: 'recent_activity',
  ALERTS: 'alerts',
  STATS: 'stats',
  CHART: 'chart',
  LIST: 'list'
};

export const WIDGET_SIZES = {
  SMALL: 'small',    // 1/4 width
  MEDIUM: 'medium',  // 1/2 width
  LARGE: 'large',    // 3/4 width
  FULL: 'full'       // full width
};

export const ACTION_COLORS = {
  PRIMARY: 'bg-blue-500 hover:bg-blue-600',
  SUCCESS: 'bg-green-500 hover:bg-green-600',
  WARNING: 'bg-orange-500 hover:bg-orange-600',
  DANGER: 'bg-red-500 hover:bg-red-600',
  INFO: 'bg-purple-500 hover:bg-purple-600',
  SECONDARY: 'bg-gray-500 hover:bg-gray-600'
};

export const ALERT_TYPES = {
  INFO: {
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-900',
    accentColor: 'text-blue-600',
    borderColor: 'border-blue-200'
  },
  SUCCESS: {
    bgColor: 'bg-green-50',
    textColor: 'text-green-900',
    accentColor: 'text-green-600',
    borderColor: 'border-green-200'
  },
  WARNING: {
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-900',
    accentColor: 'text-orange-600',
    borderColor: 'border-orange-200'
  },
  ERROR: {
    bgColor: 'bg-red-50',
    textColor: 'text-red-900',
    accentColor: 'text-red-600',
    borderColor: 'border-red-200'
  }
};

export const DEFAULT_QUICK_ACTIONS = [
  {
    id: 'new-reservation',
    name: 'New Reservation',
    href: '/reservations',
    icon: 'PlusIcon',
    description: 'Create a new equipment reservation',
    color: ACTION_COLORS.PRIMARY
  },
  {
    id: 'active-reservations',
    name: 'Active Reservations',
    href: '/reservations?status=active',
    icon: 'ClockIcon',
    description: 'View and manage active rentals',
    color: ACTION_COLORS.SUCCESS
  },
  {
    id: 'daily-report',
    name: 'Daily Report',
    href: '/reports',
    icon: 'DocumentTextIcon',
    description: 'Generate daily rental reports',
    color: ACTION_COLORS.INFO
  },
  {
    id: 'manage-inventory',
    name: 'Manage Inventory',
    href: '/inventory',
    icon: 'CogIcon',
    description: 'Update inventory items and settings',
    color: ACTION_COLORS.WARNING
  }
];

export const WIDGET_LAYOUTS = {
  GRID_2: 'grid-cols-2',
  GRID_3: 'grid-cols-3',
  GRID_4: 'grid-cols-4',
  RESPONSIVE: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
};